/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/workflow/ui_elements/common';
import '../common/workflow/ui_elements/ui_element';
import './debit_card_management';
import './credit_card_client_driven_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "CardManagementConfiguration": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "items": {
                        "type": ".squareup.bbfrontend.service.v1.CardManagementConfiguration.Item",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "logEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Item": {
                        "fields": {
                          "element": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement",
                            "id": 1,
                            "rule": "optional"
                          },
                          "debitCardFlow": {
                            "type": ".squareup.bbfrontend.service.v1.DebitCardManagement.ClientHandleableFlow",
                            "id": 2
                          },
                          "creditCardFlow": {
                            "type": ".squareup.bbfrontend.service.v1.CreditCardClientDrivenFlow",
                            "id": 3
                          },
                          "creditCardReviewCreditLimit": {
                            "type": ".squareup.bbfrontend.service.v1.CreditCardReviewCreditLimitFlow",
                            "id": 4
                          },
                          "debitCardManagement": {
                            "type": ".squareup.bbfrontend.service.v1.DebitCardManagementFlow",
                            "id": 5
                          },
                          "creditCardAutopaySettings": {
                            "type": ".squareup.bbfrontend.service.v1.CreditCardAutopaySettings",
                            "id": 6
                          },
                          "creditCardActivation": {
                            "type": ".squareup.bbfrontend.service.v1.CreditCardActivation",
                            "id": 7
                          }
                        },
                        "nested": {
                          "target_flow": {
                            "oneof": ["debitCardFlow", "creditCardFlow", "creditCardReviewCreditLimit", "debitCardManagement", "creditCardAutopaySettings", "creditCardActivation"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardManagementConfiguration?.nested?.Item) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CardManagementConfiguration @ squareup/bbfrontend/v1/card_management_configuration.proto at 15:1
 */
export const CardManagementConfiguration = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfiguration');
fixType(CardManagementConfiguration);
Builder.createAndAttachToType(CardManagementConfiguration);
/**
 * SOURCE Item @ squareup/bbfrontend/v1/card_management_configuration.proto at 30:3
 */
CardManagementConfiguration.Item = $root.lookupType('squareup.bbfrontend.service.v1.CardManagementConfiguration.Item');
fixType(CardManagementConfiguration.Item, {
  element: {
    required: true
  }
});
Builder.createAndAttachToType(CardManagementConfiguration.Item);